(function() {
	"use strict";

	angular
		.module("sempraWebapp")
		.factory("pricingActions", pricingActionsFactory);

	/** @ngInject */
	function pricingActionsFactory(api, $q) {
		return {
			getCompanyTokenPackage: getCompanyTokenPackage,
			getSingleCompanyTokenPackage: getSingleCompanyTokenPackage,
			createCompanyTokenPackage: createCompanyTokenPackage,
			updateCompanyTokenPackage: updateCompanyTokenPackage,
			deleteCompanyTokenPackage: deleteCompanyTokenPackage,
			getSingeWashes: getSingeWashes,
			getSingeWash: getSingeWash,
			createSingeWash: createSingeWash,
			updateSingeWash: updateSingeWash,
			deleteSingeWash: deleteSingeWash
		};

		function getCompanyTokenPackage() {
			var deferred = $q.defer();
			api.getCompanyTokenPackage().then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getSingleCompanyTokenPackage(id) {
			var deferred = $q.defer();
			api.getSingleCompanyTokenPackage(id).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function createCompanyTokenPackage(data) {
			var deferred = $q.defer();
			api.createCompanyTokenPackage(data).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function updateCompanyTokenPackage(data) {
			var deferred = $q.defer();
			api.updateCompanyTokenPackage(data).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function deleteCompanyTokenPackage(id) {
			var deferred = $q.defer();
			api.deleteCompanyTokenPackage(id).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getSingeWashes() {
			var deferred = $q.defer();
			api.getSingeWashes().then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getSingeWash(id) {
			var deferred = $q.defer();
			api.getSingeWash(id).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function createSingeWash(data) {
			var deferred = $q.defer();
			api.createSingeWash(data).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function updateSingeWash(data) {
			var deferred = $q.defer();
			api.updateSingeWash(data).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function deleteSingeWash(id) {
			var deferred = $q.defer();
			api.deleteSingeWash(id).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

	}
})();
